import React from 'react'
import { Container, TextOne, TextTwo, TitleContainer } from './style'
import Button from '@components/button'
import { CirclePlus } from 'lucide-react'

const Title = ({
  textone,
  texttwo,
  textthree,
  hasButton,
  btnText,
  onButtonClick,
  textOneClick,
  textTwoClick,
  textThreeClick,
}: {
  textone: string
  texttwo: string
  textthree?: string
  hasButton?: boolean
  btnText?: string
  onButtonClick?: () => void
  textOneClick?: () => void
  textTwoClick?: () => void
  textThreeClick?: () => void
}) => {
  return (
    <Container>
      <TitleContainer>
        <TextOne
          onClick={textOneClick}
          style={{ cursor: textOneClick ? 'pointer' : 'default' }}
        >
          {textone}
        </TextOne>
        <TextTwo
          onClick={textTwoClick}
          style={{ cursor: textTwoClick ? 'pointer' : 'default' }}
        >
          {texttwo}
        </TextTwo>
        {textthree && (
          <TextTwo
            onClick={textThreeClick}
            style={{ cursor: textThreeClick ? 'pointer' : 'default' }}
          >
            {textthree}
          </TextTwo>
        )}
      </TitleContainer>
      {!!hasButton && (
        <Button
          type="button"
          title={btnText || 'Create Room'}
          height={40}
          icon={<CirclePlus width={18} />}
          onClick={onButtonClick}
        />
      )}
    </Container>
  )
}

export default Title
